/**
 * ProtectedRoute — guard для приватных страниц.
 *
 * Если юзер авторизован — рендерит Outlet (дочерние маршруты).
 * Если не авторизован — редиректит на /sign-in, сохраняя в location.state.from
 * исходный путь, чтобы после логина вернуть юзера куда он хотел попасть
 * (deep-linking из писем/уведомлений).
 *
 * Пока идёт проверка сессии (isLoading) — рендерится Spinner,
 * чтобы не было моментального flash редиректа на /sign-in для уже
 * залогиненного юзера при первой загрузке.
 */

import { Navigate, Outlet, useLocation } from 'react-router';
import { useCurrentUser } from '@/features/user';
import { Spinner } from '@/components/ui/spinner';
import { ROUTE_PATHS } from '@/lib';

export function ProtectedRoute(): JSX.Element {
  const { data: user, isLoading } = useCurrentUser();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <Spinner className="size-16" />
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={ROUTE_PATHS.SIGN_IN}
        replace
        state={{ from: location.pathname + location.search + location.hash }}
      />
    );
  }

  return <Outlet />;
}
